import React, { useEffect, useState } from "react";

const KAKAO_SDK_URL = "https://t1.kakaocdn.net/kakao_js_sdk/2.7.2/kakao.min.js";
const BASE_URL = "https://gr.hynix.ai.kr";

function loadKakaoSdk() {
  return new Promise((resolve, reject) => {
    if (window.Kakao) {
      resolve(window.Kakao);
      return;
    }

    const existingScript = document.querySelector('script[src*="kakao.min.js"]');
    if (existingScript) {
      existingScript.addEventListener("load", () => resolve(window.Kakao));
      existingScript.addEventListener("error", reject);
      return;
    }

    const script = document.createElement("script");
    script.src = KAKAO_SDK_URL;
    script.async = true;
    script.onload = () => resolve(window.Kakao);
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

const KakaoShareButton = ({ restaurant }) => {
  const [sdkReady, setSdkReady] = useState(false);

  useEffect(() => {
    let mounted = true;

    const init = async () => {
      try {
        const kakao = await loadKakaoSdk();
        const jsKey = process.env.REACT_APP_KAKAO_JS_KEY;

        if (!jsKey) {
          console.error("REACT_KAKAO_JS_KEY가 없습니다.");
          return;
        }

        if (kakao && !kakao.isInitialized()) {
          kakao.init(jsKey);
        }

        if (mounted) setSdkReady(true);
      } catch (e) {
        console.error("카카오 SDK 로드 실패:", e);
      }
    };

    init();

    return () => {
      mounted = false;
    };
  }, []);

  const handleShare = () => {
  // 👇 이것만 임시로 추가
  console.log("Kakao:", window.Kakao);
  console.log("sdkReady:", sdkReady);
  console.log("JS Key:", process.env.REACT_APP_KAKAO_JS_KEY);
    if (!window.Kakao || !sdkReady) {
      alert("카카오 공유 준비 중입니다. 잠시 후 다시 시도해주세요.");
      return;
    }

    if (!restaurant?.id || !restaurant?.name) {
      alert("공유할 맛집 정보가 부족합니다.");
      return;
    }

    const shareUrl = `${BASE_URL}/?restaurantId=${restaurant.id}`;
    const descriptionParts = [
      restaurant.city,
      restaurant.category,
      restaurant.address,
    ].filter(Boolean);

    const description = descriptionParts.join(" · ");
    const imageUrl = restaurant.imageUrl || `${BASE_URL}/logo192.png`;

    window.Kakao.Share.sendDefault({
      objectType: "feed",
      content: {
        title: restaurant.koreanName
          ? `${restaurant.koreanName} (${restaurant.name})`
          : restaurant.name,
        description: description || "우리 맛집 지도에서 저장한 맛집",
        imageUrl,
        link: {
          mobileWebUrl: shareUrl,
          webUrl: shareUrl,
        },
      },
      buttons: [
        {
          title: "맛집 보러가기",
          link: {
            mobileWebUrl: shareUrl,
            webUrl: shareUrl,
          },
        },
      ],
    });
  };

  return (
    <button
      onClick={handleShare}
      style={{
        width: "100%",
        marginTop: "8px",
        padding: "10px",
        background: "#FEE500",
        color: "#191919",
        border: "1px solid #E5D200",
        borderRadius: "8px",
        cursor: "pointer",
        fontSize: "14px",
        fontWeight: "bold",
      }}
    >
      카카오톡 공유
    </button>
  );
};

export default KakaoShareButton;